import * as React from "react";

const Phone: React.FC = () => {
    return (
        <svg
            focusable="false"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
        >
            <g xmlns="http://www.w3.org/2000/svg" clipPath="url(#clip0_9010_99136)">
                <path d="M6.54 5.33325C6.6 6.22325 6.75 7.09325 6.99 7.92325L5.79 9.12325C5.38 7.92325 5.12 6.65325 5.03 5.33325H6.54ZM16.4 17.3533C17.25 17.5933 18.12 17.7433 19 17.8033V19.2933C17.68 19.2033 16.41 18.9433 15.2 18.5433L16.4 17.3533ZM7.5 3.33325H4C3.45 3.33325 3 3.78325 3 4.33325C3 13.7233 10.61 21.3333 20 21.3333C20.55 21.3333 21 20.8833 21 20.3333V16.8433C21 16.2933 20.55 15.8433 20 15.8433C18.76 15.8433 17.55 15.6433 16.43 15.2733C16.33 15.2333 16.22 15.2233 16.12 15.2233C15.86 15.2233 15.61 15.3233 15.41 15.5133L13.21 17.7133C10.38 16.2633 8.06 13.9533 6.62 11.1233L8.82 8.92325C9.1 8.64325 9.18 8.25325 9.07 7.90325C8.7 6.78325 8.5 5.58325 8.5 4.33325C8.5 3.78325 8.05 3.33325 7.5 3.33325Z" fill="currentColor"/>
            </g>
            <defs xmlns="http://www.w3.org/2000/svg">
                <clipPath id="clip0_9010_99136">
                    <rect width="24" height="24" fill="currentColor" transform="translate(0 0.333252)"/>
                </clipPath>
            </defs>
        </svg>
    );
};

export default React.memo(Phone);
